<template>
  <header class="omnistock omni-card-header">
    <slot />
  </header>
</template>

<style lang="scss">
.omnistock {
    &.omni-card-header {
        padding: 1rem;
    }
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "OmniCardHeader",
});
</script>
